import { AppDefaultNavigationState } from '../../../initialStateRegistration';

export const getNetworkLinks = (state: AppDefaultNavigationState) => state.networkLinks;
